import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { selectMe, selectPermissions } from '../../Api/selectors';
import { getPropByName } from '../../../utils/props';
import { GRANT_PERMISSIONS } from '../../../components/Permission/constants';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class KanbanPermissionsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  get permissions() {
    const permissions = getPropByName(this.props.loggedUser, 'kanbanPermissions');
    const parsedPermissions = permissions ? JSON.parse(permissions) : [];
    return parsedPermissions;
  }

  get permissionFromBoardName() {
    return this.props.boardName?.toLowerCase()?.replaceAll(' ', '_');
  }

  hasPermission() {
    if (this.props.permissions?.includes(GRANT_PERMISSIONS)) {
      return true;
    }
    const pArray = this.permissions?.map(p => p?.name);
    let isAllowed = false;

    isAllowed = pArray?.includes(this.permissionFromBoardName);

    return isAllowed;
  }

  render() {
    return <>{this.hasPermission() ? this.props.children : this.props.proxy ?? null}</>;
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    permissions: selectPermissions(),
    loggedUser: selectMe(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanPermissions = compose(withConnect, withRouter)(KanbanPermissionsComp);
